import { store, AuthActions } from "../Redux";
import { history, routerPath } from "../Config";

const LogoutFn = async () => {
    const {dispatch} = store;

    await dispatch(AuthActions.reset());
    history.push(routerPath.login);
}

export const Logout = () => {
    return LogoutFn();
};